import { render, staticRenderFns } from "./PrivacyPolicyUs.vue?vue&type=template&id=451e229e"
import script from "./PrivacyPolicyUs.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports